import React from 'react';
import Card from './Card';
import './DiscardPile.css';

/**
 * Display the discard pile (top card) for UNO
 */
const DiscardPile = ({ topCard, drawPileCount }) => {
  if (!topCard) {
    return (
      <div className="discard-pile empty">
        <div className="discard-pile-back">
          <span>🃏</span>
        </div>
      </div>
    );
  }

  return (
    <div className="discard-pile">
      <div className="discard-pile-card">
        <Card card={topCard} size="large" />
      </div>
      <div className="discard-pile-info">
        <span className="draw-pile-count">{drawPileCount || 0} cards left</span>
      </div>
    </div>
  );
};

export default DiscardPile;
